import React, { useState, useEffect } from "react";
import "./DomainsTabsNew.css";
import DomainsRolebasedEngineeringData from "../data/DomainsRolebasedEngineeringData.json";
import DomainsRolebasedRetailData from "../data/DomainsRolebasedRetailData.json";
import DomainsRolebasedWholesaleData from "../data/DomainsRolebasedWholesaleData.json";
import AOS from "aos";
import "aos/dist/aos.css";

import { useMsal } from "@azure/msal-react";

function DomainsTabsNew() {
  const [username, setUsername] = React.useState();
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();
  useEffect(() => {
    if (activeAccount) setUsername(activeAccount.idTokenClaims.enterpriseID);
  }, [activeAccount]);
  useEffect(() => {
    AOS.init({ duration: 800 });
  }, []);

  return (
    <>
      <div className="tabs-holder">
        <ul class="nav nav-tabs" id="myTab" role="tablist">
          <li class="nav-item" role="presentation">
            <button
              class="nav-link active"
              id="home-tab"
              data-bs-toggle="tab"
              data-bs-target="#home"
              type="button"
              role="tab"
              aria-controls="home"
              aria-selected="true"
            >
              <h3>
                <span className="course-level">Engineering and Enterprise</span>
              </h3>
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button
              class="nav-link"
              id="profile-tab"
              data-bs-toggle="tab"
              data-bs-target="#profile"
              type="button"
              role="tab"
              aria-controls="profile"
              aria-selected="false"
            >
              <h3>
                <span className="course-level">Retail NL Tech</span>
              </h3>
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button
              class="nav-link"
              id="contact-tab"
              data-bs-toggle="tab"
              data-bs-target="#contact"
              type="button"
              role="tab"
              aria-controls="contact"
              aria-selected="false"
            >
              <h3>
                <span className="course-level">Wholesale and Rural</span>
              </h3>
            </button>
          </li>
        </ul>
      </div>
      <div class="tab-content" id="myTabContent">
        <div
          class="tab-pane fade show active"
          id="home"
          role="tabpanel"
          aria-labelledby="home-tab"
        >
          <div className="domains-sec">
            <div className="domains-text-box">
              <p>
                Welcome to Engineering and Enterprise, where the convergence of
                Data Engineering, Data Science, and Python Programming providing
                IT services to enable easy banking, smooth customer service and
                rapid new product development to form the nexus of
                transformative learning.
              </p>
            </div>
            <div className="domains-wrap">
              {DomainsRolebasedEngineeringData.map((post) => {
                return (
                  <div
                    key={post.id}
                    className="domains-row"
                    data-aos="zoom-in-up"
                  >
                    <div className="domains-box">
                      <div className="domains-img-box">
                        <a href={post.courselink} target="_blank">
                          <img
                            src={process.env.PUBLIC_URL + post.courseimg}
                            // src={post.courseimg}
                            alt="course"
                            className="course-tile-img"
                          />
                        </a>
                      </div>
                      <div className="domains-extra-box">
                        <h3>{post.coursehead}</h3>
                        <p className="domains-para">{post.coursetext}</p>

                        <p className="pre-assess-link">
                          <button
                            // onClick={() => {
                            //   openPreassessmentWindow("preassessment");
                            // }}
                            className="pre-assess-disable-btn"
                            // disabled={
                            //   (userProficiency != undefined &&
                            //     userProficiency.length != 0) ||
                            //   count > 2
                            //     ? true
                            //     : false
                            // }
                          >
                            Take Pre-assessment
                          </button>
                        </p>

                        <p className="learning-link">
                          <a href={post.courselink} target="_blank">
                            Go to Learning
                          </a>
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <div
          class="tab-pane fade"
          id="profile"
          role="tabpanel"
          aria-labelledby="profile-tab"
        >
          <div className="domains-sec">
            <div className="domains-text-box">
              <p>
                Retail NL tech focus on establishing/maintaining relationship
                between Bank and customers. Provide multiple ways for customers
                to reach out banks and make their day-to-day banking easier.
              </p>
            </div>
            <div className="domains-wrap">
              {DomainsRolebasedRetailData.map((post) => {
                return (
                  <div
                    key={post.id}
                    className="domains-row"
                    data-aos="zoom-in-up"
                  >
                    <div className="domains-box">
                      <div className="domains-img-box">
                        <a href={post.courselink} target="_blank">
                          <img
                            src={process.env.PUBLIC_URL + post.courseimg}
                            // src={post.courseimg}
                            alt="course"
                            className="course-tile-img"
                          />
                        </a>
                      </div>
                      <div className="domains-extra-box">
                        <h3>{post.coursehead}</h3>
                        <p className="domains-para">{post.coursetext}</p>
                        {/* <p className="pre-assess-link">
                          <button
                            onClick={openPreassessmentWindow}
                            className="pre-assess-disable-btn"
                            disabled={
                              (userProficiency != undefined &&
                                userProficiency.length != 0) ||
                              count > 2
                                ? true
                                : false
                            }
                          >
                            Take Pre-assessment
                          </button>
                        </p> */}
                        {/* <p className="learning-link">
                          <a href={post.courselink} target="_blank">
                            Go to Learning
                          </a>
                        </p> */}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <div
          class="tab-pane fade"
          id="contact"
          role="tabpanel"
          aria-labelledby="contact-tab"
        >
          <div className="domains-sec">
            <div className="domains-text-box">
              <p>
                Welcome to Wholesale and Rural tech, where we provide high
                quality and cost-effective products on a future proof technology
                & platform to our client, driving digital transformation with
                regulatory compliance while knitting the global F&A network
                together and competitive cost on a future proof technology &
                platform.
              </p>
            </div>
            <div className="domains-wrap">
              {DomainsRolebasedWholesaleData.map((post) => {
                return (
                  <div
                    key={post.id}
                    className="domains-row"
                    data-aos="zoom-in-up"
                  >
                    <div className="domains-box">
                      <div className="domains-img-box">
                        <a href={post.courselink} target="_blank">
                          <img
                            src={process.env.PUBLIC_URL + post.courseimg}
                            // src={post.courseimg}
                            alt="course"
                            className="course-tile-img"
                          />
                        </a>
                      </div>
                      <div className="domains-extra-box">
                        <h3>{post.coursehead}</h3>
                        <p className="domains-para">{post.coursetext}</p>
                        {/* <p className="pre-assess-link">
                          <button
                            onClick={openPreassessmentWindow}
                            className="pre-assess-disable-btn"
                            disabled={
                              (userProficiency != undefined &&
                                userProficiency.length != 0) ||
                              count > 2
                                ? true
                                : false
                            }
                          >
                            Take Pre-assessment
                          </button>
                        </p> */}
                        {/* <p className="learning-link">
                          <a href={post.courselink} target="_blank">
                            Go to Learning
                          </a>
                        </p> */}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default DomainsTabsNew;
